
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar/about",
      function () {
        return require("private-next-pages/ar/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar/about"])
      });
    }
  